import { useTranslation } from "react-i18next";
import { NavbarDropDown } from "./NavbarDropDown";
import { ReactComponent as HomeIcon } from "shared/assets/Icons/home.svg";
import { ReactComponent as AccountIcon } from "shared/assets/Icons/account.svg";
import { ReactComponent as ClientsIcon } from "shared/assets/Icons/clients.svg";
import { ReactComponent as DualBrandingIcon } from "shared/assets/Icons/settings.svg";
import { ReactComponent as CommunicationsIcon } from "shared/assets/Icons/bell.svg";
import { ReactComponent as PendingNotificationsIcon } from "shared/assets/Icons/pending.svg";
import { ReactComponent as PaperClipIcon } from "shared/assets/Icons/paper-clip.svg";
import { ProtectedNavbarItem } from "./ProtectedNavbarItem";
import RouteAuthorisation from "core/auth/routeAuthorisation";

export const NavigationItems = (props: { isDrawerOpen: boolean }) => {
  const { t } = useTranslation();

  return (
    <>
      <ProtectedNavbarItem
        requiredAuthorisations={RouteAuthorisation.dashboard}
        href={"/dashboard"}
        name={t("dashboard.title")}
        Icon={HomeIcon}
        isExpanded={props.isDrawerOpen}
      />
      <NavbarDropDown
        title={t("navbarHeaders.users")}
        Icon={AccountIcon}
        isExpanded={props.isDrawerOpen}
        forAnyOf={[RouteAuthorisation.viewHaAdmins, RouteAuthorisation.viewClientAdmins, RouteAuthorisation.viewWisdomUsers]}
      >
        <ProtectedNavbarItem
          requiredAuthorisations={RouteAuthorisation.viewHaAdmins}
          href={"/usermanagement/wwadmins"}
          name={t("wwAdminManagement.navBarTitle")}
          Icon={null}
          isExpanded={props.isDrawerOpen}
        />
        <ProtectedNavbarItem
          requiredAuthorisations={RouteAuthorisation.viewClientAdmins}
          href={"/usermanagement/clientadmins"}
          name={t("clientAdminManagement.navBarTitle")}
          Icon={null}
          isExpanded={props.isDrawerOpen}
        />
        <ProtectedNavbarItem
          requiredAuthorisations={RouteAuthorisation.viewWisdomUsers}
          href={"/usermanagement/wisdomusers"}
          name={t("userManagement.navBarTitle")}
          Icon={null}
          isExpanded={props.isDrawerOpen}
        />
      </NavbarDropDown>
      <NavbarDropDown
        title={t("navbarHeaders.clients")}
        Icon={ClientsIcon}
        isExpanded={props.isDrawerOpen}
        forAnyOf={[RouteAuthorisation.viewClients, RouteAuthorisation.targetGroups, RouteAuthorisation.importClients]}
      >
        <ProtectedNavbarItem
          requiredAuthorisations={RouteAuthorisation.viewClients}
          href={"/clientmanagement"}
          name={t("clientManagement.navBarTitle")}
          Icon={null}
          isExpanded={props.isDrawerOpen}
        />
        <ProtectedNavbarItem
          requiredAuthorisations={RouteAuthorisation.targetGroups}
          href={"/targetgroups"}
          name={t("targetGroups.navBarTitle")}
          Icon={null}
          isExpanded={props.isDrawerOpen}
        />
        <ProtectedNavbarItem
          requiredAuthorisations={RouteAuthorisation.importClients}
          href={"/importclients"}
          name={t("importClients.navBarTitle")}
          Icon={null}
          isExpanded={props.isDrawerOpen}
        />
      </NavbarDropDown>
      <ProtectedNavbarItem
        requiredAuthorisations={RouteAuthorisation.hubSites}
        href={"/hub-sites"}
        name={t("hubSites.navBarTitle")}
        Icon={PaperClipIcon}
        isExpanded={props.isDrawerOpen}
      />
      <ProtectedNavbarItem
        requiredAuthorisations={RouteAuthorisation.dualBranding}
        href={"/dualbranding"}
        name={t("dualBranding.navbarTitle")}
        Icon={DualBrandingIcon}
        isExpanded={props.isDrawerOpen}
      />
      <ProtectedNavbarItem
        requiredAuthorisations={RouteAuthorisation.sendCommunications}
        href={"/communications"}
        name={t("communications.navBarTitle")}
        Icon={CommunicationsIcon}
        isExpanded={props.isDrawerOpen}
      />
      <ProtectedNavbarItem
        requiredAuthorisations={RouteAuthorisation.pushNotifications}
        href={"/pending-notifications"}
        name={t("pendingNotifications.navBarTitle")}
        Icon={PendingNotificationsIcon}
        isExpanded={props.isDrawerOpen}
      />
    </>
  );
};
